// Realistic mock jobs for the Phase-1 UI (no backend yet). Replaced by live Firestore
// data in Phase 2. Labels are generic on purpose — no real client/job names.
//
// Each processing job belongs to a `shoot` (the parent client Job/booking). The Queue,
// Processing, and History views group by shoot.
//
// Job shape:
//   id, label, shoot: {id, label}, subjectType, recipeId, controlSet, photoCount,
//   source, priority,
//   status: "queued" | "processing" | "complete" | "failed",
//   created (display string),
//   processing: { step (index into PIPELINE_STEPS), progress (0-100), started }
//   complete:   { duration, completedAt }
//   failed:     { failedStep, error, failedAt }

const BOOTH = { id: "booth_jun2", label: "Booth Day · Jun 2" };
const PROPS = { id: "tabletop_props", label: "Tabletop · Props" };
const VEHICLES = { id: "field_vehicles", label: "Field · Vehicles" };

export const MOCK_JOBS = [
  // ---- Queue ------------------------------------------------------------------
  {
    id: "ac_2041",
    label: "Subject · Standing A-pose",
    shoot: BOOTH,
    subjectType: "person",
    recipeId: "high_1m_100k_glb_usdz",
    controlSet: "body",
    photoCount: 176,
    source: "captures/cap_044",
    priority: 1,
    status: "queued",
    created: "8m ago",
  },
  {
    id: "ac_2040",
    label: "Hero Prop · Wooden Chair",
    shoot: PROPS,
    subjectType: "prop",
    recipeId: "high_1m_50k_smoothed_glb",
    controlSet: "traveling_tabletop",
    photoCount: 142,
    source: "captures/cap_043",
    priority: 0,
    status: "queued",
    created: "22m ago",
  },
  {
    id: "ac_2039",
    label: "Sedan (exterior)",
    shoot: VEHICLES,
    subjectType: "vehicle",
    recipeId: "normal_1m_100k_glb_usdz",
    controlSet: "body",
    photoCount: 311,
    source: "captures/cap_041",
    priority: 0,
    status: "queued",
    created: "1h ago",
  },

  // ---- Processing -------------------------------------------------------------
  {
    id: "ac_2038",
    label: "Subject · Seated",
    shoot: BOOTH,
    subjectType: "person",
    recipeId: "high_1m_100k_glb_usdz",
    controlSet: "body",
    photoCount: 168,
    source: "captures/cap_040",
    priority: 0,
    status: "processing",
    processing: { step: 2, progress: 38, started: "12m ago" },
  },
  {
    id: "ac_2037",
    label: "Display Helmet",
    shoot: PROPS,
    subjectType: "prop",
    recipeId: "high_1m_50k_smoothed_glb",
    controlSet: "compact_plate",
    photoCount: 98,
    source: "captures/cap_039",
    priority: 0,
    status: "processing",
    processing: { step: 4, progress: 71, started: "26m ago" },
  },

  // ---- History ----------------------------------------------------------------
  {
    id: "ac_2036",
    label: "Subject · T-pose",
    shoot: BOOTH,
    subjectType: "person",
    recipeId: "high_1m_100k_glb_usdz",
    controlSet: "body",
    photoCount: 180,
    status: "complete",
    complete: { duration: "16 min", completedAt: "Today · 11:42" },
  },
  {
    id: "ac_2035",
    label: "Ceramic Vase",
    shoot: PROPS,
    subjectType: "prop",
    recipeId: "high_1m_50k_smoothed_glb",
    controlSet: "traveling_tabletop",
    photoCount: 120,
    status: "complete",
    complete: { duration: "9 min", completedAt: "Today · 09:15" },
  },
  {
    id: "ac_2034",
    label: "Coupe (exterior)",
    shoot: VEHICLES,
    subjectType: "vehicle",
    recipeId: "normal_1m_100k_glb_usdz",
    controlSet: "body",
    photoCount: 287,
    status: "failed",
    failed: {
      failedStep: "Align",
      error: "Alignment produced 3 components — markers not detected on the rear plates.",
      failedAt: "Yesterday · 18:30",
    },
  },
  {
    id: "ac_2033",
    label: "Head Scan · Profile",
    shoot: BOOTH,
    subjectType: "person",
    recipeId: "high_1m_100k_glb_usdz",
    controlSet: "head",
    photoCount: 96,
    status: "complete",
    complete: { duration: "7 min", completedAt: "Yesterday · 16:02" },
  },
];

export const SUBJECT_TYPE_LABELS = {
  person: "Person",
  vehicle: "Vehicle",
  prop: "Prop",
  other: "Object",
};
